import React, { useState, useContext, useEffect } from 'react';
import i18next from "../../i18n.js";
import { hideModalDialog, showModalDialog } from '../ModalDialog.js';
import { Svg } from '../Svg.js';
import { CommentForm } from './CommentForm.js';
import { UserContext, resources } from '../../constants.js';
import { loadAvatar } from '../helpers/HelperFunctions.js';

export const Comment = (props) => {
    const userContext = useContext(UserContext);
    const [imgUrl, setImgUrl] = useState('');
    const [showEditField, setShowEditField] = useState(false);
    const [showReplyField, setShowReplyField] = useState(false);

    const { commentBeanList, id, userFullName, created, userName, content } = props.comment;
    const { parentCommentId, documentId } = props;

    useEffect(() => {
        loadAvatar(userName, userName).then(url => {
            setImgUrl(url ?? resources.defaulUserImg);
        });
    }, [userName]);

    const btns = [
        {
            key: 'delete',
            onClick: () => showModalDialog('modalDialog', i18next.t("message"), "", i18next.t("document.deleteCommentMessage"), "feedPopup", true, [{ title: i18next.t("yes"), clickHandler: deleteComent, class: "btn-primary" }, { title: i18next.t("no"), clickHandler: () => hideModalDialog('modalDialog'), class: "btn-secondary" }]),
            svg: { src: "/img/comments/delete.svg" }, forAuthor: true
        },
        {
            key: 'edit',
            onClick: () => setShowEditField(true),
            svg: { src: "/img/comments/edit.svg" }, forAuthor: true
        },
        {
            key: 'reply',
            onClick: () => setShowReplyField(true),
            svg: { src: "/img/comments/reply.svg" }
        }
    ];

    const editComment = async (comment) => {
        const { id, content, userName } = comment;
        await buildCommentAction('POST', '/api/comments/crud', {
            action: 'editComment',
            parentCommentPath: `${(parentCommentId ? `${parentCommentId}|` : "")}${id}`,
            content: content,
            documentNodeRef: documentId,
            userName: userName
        });
        props.getComents();
        setShowEditField(false);
    }

    const replyComment = async (subComment) => {
        await buildCommentAction('POST', '/api/comments/crud', {
            action: 'addSubComment',
            parentCommentPath: `${(parentCommentId ? `${parentCommentId}|` : "")}${id}`,
            content: subComment.content,
            documentNodeRef: documentId,
        });
        props.getComents();
        setShowReplyField(false);
    }

    const deleteComent = async () => {
        await buildCommentAction('POST', '/api/comments/crud', {
            action: "removeComment",
            parentCommentPath: `${(parentCommentId ? `${parentCommentId}|` : "")}${id}`,
            documentNodeRef: documentId,
            userName: userName
        });
        props.getComents();
        hideModalDialog('modalDialog');
    }

    return (
        <div id={id} className="comment-block">
            <div className="comment">
                <div className="comment-header">
                    <div className="comment-header-info">
                        <div className="avatar">
                            {imgUrl && <img src={imgUrl} />}
                        </div>
                        <div>
                            <div className="name">{userFullName}</div>
                            <div className="date">{created}</div>
                        </div>
                    </div>
                    <div className="action">
                        {btns.filter(btn => props.canReply || (btn.key !== 'reply' && btn.key !== 'answers')).map((item, index) => <button key={index} type="button" style={item.forAuthor ? { display: ((userContext?.login === userName || !props.documentId) ? "" : "none") } : {}}
                            className={!item.className ? "btn" : item.className} onClick={item.onClick}>
                            {item.svg ? < Svg src={item.svg.src ?? ''} /> : ''}{item.text ? item.text : ''}
                        </button>)}
                    </div>
                </div>
                {!showEditField && <div className="comment-text">{content}</div>}
                {showEditField && <CommentForm key="edit-field" handleChangeComment={editComment} comment={props.comment} onCancel={() => setShowEditField(false)} />}
            </div>
            {showReplyField && <CommentForm key="reply-field" handleChangeComment={replyComment} onCancel={() => setShowReplyField(false)} isAnswer={true} />}
            {commentBeanList?.length > 0 && <div className="comments">
                {commentBeanList?.map((item) =>
                    <Comment key={item.id} parentCommentId={`${(parentCommentId ? `${parentCommentId}|` : "")}${id}`} documentId={documentId} comment={item} getComents={props.getComents} />
                )}
            </div>}
        </div>
    );
}

export const buildCommentAction = async (method, url, body) => {
    const response = await fetch(url, {
        method: method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
    });
    if (url.indexOf('get') !== -1) {
        const result = await response.json();
        return Array.isArray(result) ? result : undefined;
    }
}